import * as React from "react"
import AppBar, { AppBarTypeMap } from "@mui/material/AppBar"
import { styled, Theme } from "@mui/material/styles"
import { meshBgNavImageUri, meshBgImageReverseUri, meshBgHeaderImageReverseUri } from "../../styles/BackgroundStyles"

function getBackgroundStyles(theme: Theme) {
  switch (theme.themeName) {
    case "Fabriq":
      return {
        borderBottom: `1px solid ${theme.basePalette.border}`,
        background: theme.palette.background.default
      }
    default:
      return {
        background: theme.palette.background.default
      }
  }
}

export const AppBarLight = styled(AppBar)<AppBarTypeMap>(({ theme }) => {
  return {
    "&.MuiPaper-root": {
        borderRadius: 0,
        boxShadow: "none",
        border: "none",
        ...getBackgroundStyles(theme)
    },
    "& .MuiToolbar-root": {
        minHeight: 60
    }
  }
})
